import React from 'react'
import './WinAnimation.css'
import {SuitSymbol} from './SuitSymbol'
import {random} from '../../../utils'

let symbols: SuitSymbol[] = []

interface Props {
    onClick: Function
}

export class WinAnimation extends React.Component<Props, {}> {
    private readonly canvas: React.RefObject<HTMLCanvasElement>

    constructor(props: Props) {
        super(props)
        this.canvas = React.createRef()
    }

    render(): JSX.Element {
        const width = window.innerWidth
        const height = window.innerHeight

        return (
            <canvas
                ref={this.canvas}
                className="WinAnimation"
                width={width}
                height={height}
                style={{
                    width: width + 'px',
                    height: height + 'px',
                }}
                onClick={() => this.props.onClick && this.props.onClick()}
            />
        )
    }

    componentDidMount(): void {
        for (let i = 0; i < 10; i++) {
            let x = random(0, window.innerWidth - 50)
            let y = random(0, window.innerHeight) * -1
            symbols.push(new SuitSymbol(x, y))
        }
        this.animation(Date.now())
    }

    animation(time: number) {
        const {current} = this.canvas
        const timeout = Date.now() - time

        if (current) {
            const ctx = current.getContext('2d', {
                alpha: true,
            }) as CanvasRenderingContext2D

            for (let i = 0; i < symbols.length; i++) {
                let symbol = symbols[i]
                symbol.animate(ctx, timeout)

                for (let j = 0; j < symbols.length; j++) {
                    if (i !== j) {
                        let otherSymbol = symbols[j]

                        if (otherSymbol.intersection(symbol)) {
                            // symbol.draw(ctx, true)
                            // otherSymbol.draw(ctx, true)
                            otherSymbol.draw(ctx)
                        }
                    }
                }
            }
            let time = Date.now()
            requestAnimationFrame(() => this.animation(time))
        }
    }
}
